/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Contact
 */
export interface Contact {
    /**
     * 
     */
    name?: string;
    /**
     * 
     */
    number1?: string;
    /**
     * 
     */
    number1_code?: string;
    /**
     * 
     */
    number1_code_definition?: string;
    /**
     * 
     */
    number2?: string;
    /**
     * 
     */
    number2_code?: string;
    /**
     * 
     */
    number2_code_definition?: string;
}

/**
 * Check if a given object implements the Contact interface.
 */
export function instanceOfContact(value: object): value is Contact {
    return true;
}

export function ContactFromJSON(json: any): Contact {
    return ContactFromJSONTyped(json, false);
}

export function ContactFromJSONTyped(json: any, ignoreDiscriminator: boolean): Contact {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'number1': json['number1'] == null ? undefined : json['number1'],
        'number1_code': json['number1_code'] == null ? undefined : json['number1_code'],
        'number1_code_definition': json['number1_code_definition'] == null ? undefined : json['number1_code_definition'],
        'number2': json['number2'] == null ? undefined : json['number2'],
        'number2_code': json['number2_code'] == null ? undefined : json['number2_code'],
        'number2_code_definition': json['number2_code_definition'] == null ? undefined : json['number2_code_definition'],
    };
}

export function ContactToJSON(json: any): Contact {
    return ContactToJSONTyped(json, false);
}

export function ContactToJSONTyped(value?: Contact | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'number1': value['number1'],
        'number1_code': value['number1_code'],
        'number1_code_definition': value['number1_code_definition'],
        'number2': value['number2'],
        'number2_code': value['number2_code'],
        'number2_code_definition': value['number2_code_definition'],
    };
}

